import { defineStore } from 'pinia'

export const useProfileStore = defineStore('profile', () => {
  // Stav pro zobrazení formuláře pro vyplnění profilu
  const isProfileIncomplete = ref(false)

  // Metody pro práci se stavem
  function setProfileIncomplete(value: boolean) {
    isProfileIncomplete.value = value
  }

  return {
    isProfileIncomplete,
    setProfileIncomplete
  }
})
